import React, { useContext } from "react";
import FormContext from "../FormContext";

export default function useForm() {
  const [formData, setFormData] = useContext(FormContext);

  const onChangeHandler = (value, props, search) => {
    if (props.name && search) {
      setFormData({ [props.name]: value, page: [] });
    } else if (props.name) {
      const filterObj = Object.fromEntries(
        Object.entries(formData).filter(([key]) => key !== "query")
      );
      setFormData({ ...filterObj, [props.name]: value, page: [] });
    }
    if (props?.onChange) {
      props.onChange(value);
    }
  };
  return [onChangeHandler, formData];
}
